import type {Cta, DownloadMenu, SignUpField} from '../../../Index.types'
import {MonaHead, type MonaHeadProps} from '../../generic/MonaHead/MonaHead'
import {ColorDivider} from '../../generic/ColorDivider/ColorDivider'
import {EyebrowBanner, type EyebrowBannerProps} from '../../generic/EyebrowBanner/EyebrowBanner'

import Styles from './IntroSection.module.css'

export interface IntroSectionProps {
  eyebrowBanner?: EyebrowBannerProps
  title: string
  loggedIn: boolean
  isOrgAdmin: boolean
  ctas: {
    trial: Cta
    sales: Cta
    signUp: SignUpField
    downloadCta: Cta
    downloadMenu: DownloadMenu
  }
  monaHead: MonaHeadProps
}

export type IntroSectionPropsData = Omit<IntroSectionProps, 'loggedIn' | 'isOrgAdmin' | 'monaHead'>

export const defaultProps: Partial<IntroSectionProps> = {}

export const IntroSection = (props: IntroSectionProps) => {
  const initializedProps: IntroSectionProps = {...defaultProps, ...props}
  const {eyebrowBanner, monaHead} = initializedProps

  return (
    <div className={Styles['IntroSection']}>
      {eyebrowBanner && <EyebrowBanner {...eyebrowBanner} />}
      <MonaHead {...monaHead} />
      <ColorDivider variant="1" />
    </div>
  )
}
